import classNames from 'classnames';
import { FC, useCallback, useState } from 'react';

import RawHtml from '../../components/RawHtml';
import GravityForm from '../../content-blocks/GravityForms/GravityForm';
import GravityFormSuccess from '../../content-blocks/GravityForms/GravityFormSuccess';
import { GravityFormFragmentAttributes } from '../../content-blocks/GravityForms/types';
import SectionTitle from '../../layout/Section/SectionTitle';

import style from './form.module.css';

interface FormProps {
  description: null | string | undefined;
  disclaimer: null | string | undefined;
  gravityForm: GravityFormFragmentAttributes['form'];
  title: null | string | undefined;
}

const Form: FC<FormProps> = ({
  description,
  disclaimer,
  gravityForm,
  title,
}) => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = useCallback(() => {
    setIsSuccess(true);
  }, []);

  return (
    <div className={style.container}>
      <div
        className={classNames(
          style.successContainer,
          style.animated,
          {
            [style.hidden]: !isSuccess,
            [style.inFromRight]: !isSuccess,
          },
        )}
      >
        {isSuccess && (
          <GravityFormSuccess confirmations={gravityForm?.confirmations} />
        )}
      </div>

      {title && (
        <SectionTitle
          className={classNames(
            style.title,
            style.animated,
            {
              [style.hidden]: isSuccess,
              [style.outToLeft]: isSuccess,
            },
          )}
        >
          {title}
        </SectionTitle>
      )}

      {description && (
        <RawHtml
          className={classNames(
            style.description,
            style.animated,
            {
              [style.hidden]: isSuccess,
              [style.outToLeft]: isSuccess,
            },
          )}
        >
          {description}
        </RawHtml>
      )}

      <div
        className={classNames(
          style.gravityFormsContainer,
          style.animated,
          {
            [style.hidden]: isSuccess,
            [style.outToLeft]: isSuccess,
          },
        )}
      >
        <GravityForm
          disclaimer={disclaimer}
          form={gravityForm}
          onSuccess={handleSuccess}
        />
      </div>
    </div>
  );
};

export default Form;
